module.exports = __webpack_public_path__ + "img/arrow_down_grey.cb5e047e.svg";